export const sentenceCase = (str: string): string => {
  if (!str) {
    return "";
  }

  const replaceHyphenWithEmptySpace = (str: string): string => {
    return str.replace(/-/g, " ");
  };

  const sentence = replaceHyphenWithEmptySpace(str);
  const firstLetter = sentence.charAt(0).toUpperCase();
  const restOfSentence = sentence.slice(1).toLowerCase();
  return `${firstLetter}${restOfSentence}`;
};
